import React from 'react'
import { createRoot } from 'react-dom/client'
import { keycloak } from './lib'
import { App } from './App'
import '@tomra/design-system/src/config/tailwind.config.css'

const container = document.getElementById('root')
const root = createRoot(container as HTMLDivElement)

const Index = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256' }).then(() => {
  root.render(<Index />)
})
